/**
 * @generated SignedSource<<aa4f0ae977b2c9361756ffbf741314bd>>
 * @relayHash a2b7f78fbc7a4e9ecead01083cfe8f24
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

// @relayRequestID e2f8168270ed250fa33f38610fa3b20029664886f16e5db1184bbca7a9821266

import type { ConcreteRequest } from 'relay-runtime';
export type SmartCreateFeedbackBannerQuery$variables = {
  contentId: string;
};
export type SmartCreateFeedbackBannerQuery$data = {
  readonly singleContent: {
    readonly contentProperties: {
      readonly draft: {
        readonly generatedBy: string | null | undefined;
      } | null | undefined;
      readonly latest: {
        readonly generatedBy: string | null | undefined;
      } | null | undefined;
    } | null | undefined;
    readonly creatorId: string | null | undefined;
    readonly id: string | null | undefined;
    readonly title: string | null | undefined;
    readonly type: string | null | undefined;
  } | null | undefined;
};
export type SmartCreateFeedbackBannerQuery = {
  response: SmartCreateFeedbackBannerQuery$data;
  variables: SmartCreateFeedbackBannerQuery$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "contentId"
  }
],
v1 = [
  {
    "kind": "ScalarField",
    "name": "generatedBy"
  }
],
v2 = [
  {
    "args": [
      {
        "kind": "Variable",
        "name": "id",
        "variableName": "contentId"
      }
    ],
    "concreteType": "Content",
    "kind": "LinkedField",
    "name": "singleContent",
    "plural": false,
    "selections": [
      {
        "kind": "ScalarField",
        "name": "title"
      },
      {
        "kind": "ScalarField",
        "name": "id"
      },
      {
        "kind": "ScalarField",
        "name": "type"
      },
      {
        "kind": "ScalarField",
        "name": "creatorId"
      },
      {
        "concreteType": "ContentProperties",
        "kind": "LinkedField",
        "name": "contentProperties",
        "plural": false,
        "selections": [
          {
            "concreteType": "DraftContentProperties",
            "kind": "LinkedField",
            "name": "draft",
            "plural": false,
            "selections": (v1/*: any*/)
          },
          {
            "concreteType": "PublishedContentProperties",
            "kind": "LinkedField",
            "name": "latest",
            "plural": false,
            "selections": (v1/*: any*/)
          }
        ]
      }
    ]
  }
];
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "name": "SmartCreateFeedbackBannerQuery",
    "selections": (v2/*: any*/),
    "type": "Query"
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "SmartCreateFeedbackBannerQuery",
    "selections": (v2/*: any*/)
  },
  "params": {
    "cacheID": "a2b7f78fbc7a4e9ecead01083cfe8f24",
    "id": "e2f8168270ed250fa33f38610fa3b20029664886f16e5db1184bbca7a9821266",
    "metadata": {},
    "name": "SmartCreateFeedbackBannerQuery",
    "operationKind": "query",
    "text": "query SmartCreateFeedbackBannerQuery($contentId:ID!){singleContent(id:$contentId){title,id,type,creatorId,contentProperties{draft{generatedBy},latest{generatedBy}}}}"
  }
};
})();

(node as any).hash = "4f4f276100c2961c7227836999fc58e5";

export default node;
